import hotel from './hotel.jpg'
import hallway3 from './hallway3.jpg'
import bar from './bar.jpg'
import beauty1 from './beauty1.jpg'
import room5 from './room5.jpg'
import beauty10 from './beauty10.jpg'
import dining4 from './dining4.jpg'
import beauty2 from './beauty2.jpg'
import tree from './tree.jpg'
import beauty9 from './beauty9.jpg'
import beach2 from './beach2.jpg'
import doors from './doors.jpg'
import beauty3 from './beauty3.jpg'
import stairs from './stairs.jpg'
import hotel3 from './hotel3.jpg'
import room3 from './room3.jpg'
import shower2 from './shower2.jpg'
import dining from './dining.jpg'
import pier from './pier.jpg'
import beauty4 from './beauty4.jpg'
import hallway2 from './hallway2.jpg'
import bathroom2 from './bathroom2.jpg'
import room2 from './room2.jpg'
import bathroom3 from './bathroom3.jpg'
import hotel5 from './hotel5.jpg'
import room6 from './room6.jpg'
import hallway5 from './hallway5.jpg'
import beauty5 from './beauty5.jpg'
import upstairs from './upstairs.jpg'
import dining3 from './dining3.jpg'
import room4 from './room4.jpg'
import hotel2 from './hotel2.jpg'
import bathroom from './bathroom.jpg'
import beauty6 from './beauty6.jpg'
import beach from './beach.jpg'
import dining2 from './dining2.jpg'
import room from './room.jpg'
import stairs2 from './stairs2.jpg'
import beauty7 from './beauty7.jpg'
import shower from './shower.jpg'
import beauty8 from './beauty8.jpg'
import hallway from './hallway.jpg'

const photos = [
  { src: hotel, width: 3024, height: 1682 },
  { src: hallway3, width: 4, height: 5 },
  { src: bar, width: 4, height: 3 },
  { src: beauty1, width: 4, height: 5 },
  { src: room5, width: 4, height: 3 },
  { src: beauty10, width: 5, height: 4 },
  { src: dining4, width: 4, height: 5 },
  { src: beauty2, width: 4, height: 5 },
  { src: tree, width: 4, height: 3 },
  { src: beauty9, width: 4, height: 5 },
  { src: beach2, width: 1024, height: 669 },
  { src: doors, width: 4, height: 3 },
  { src: beauty3, width: 4, height: 5 },
  { src: stairs, width: 4, height: 3 },
  { src: hotel3, width: 4, height: 5 },
  { src: room3, width: 4, height: 3 },
  { src: shower2, width: 3, height: 4 },
  { src: dining, width: 4, height: 5 },
  { src: pier, width: 4, height: 3 },
  { src: beauty4, width: 4, height: 5 },
  { src: hallway2, width: 4, height: 3 },
  { src: bathroom2, width: 3, height: 4 },
  { src: room2, width: 4, height: 3 },
  { src: bathroom3, width: 3, height: 4 },
  { src: hotel5, width: 4, height: 5 },
  { src: room6, width: 4, height: 3 },
  { src: hallway5, width: 4, height: 5 },
  { src: beauty5, width: 4, height: 5 },
  { src: upstairs, width: 4, height: 3 },
  { src: dining3, width: 4, height: 5 },
  { src: room4, width: 4, height: 3 },
  { src: hotel2, width: 4, height: 3 },
  { src: bathroom, width: 3, height: 4 },
  { src: beauty6, width: 4, height: 5 },
  { src: beach, width: 2, height: 1 },
  { src: dining2, width: 4, height: 5 },
  { src: room, width: 4, height: 3 },
  { src: stairs2, width: 4, height: 3 },
  { src: beauty7, width: 4, height: 5 },
  { src: shower, width: 3, height: 4 },
  { src: beauty8, width: 3, height: 4 },
  { src: hallway, width: 3, height: 4 },
]

export default photos
